<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            The General Ledger (OBE)
            <div class="settings-header__btn">
              <el-button size="mini" @click="openJournals">Journals</el-button>
              <el-button size="mini" @click="routerLink('general-ledger')">General Ledger</el-button>
              <el-button size="mini" @click="routerLink('settings-coa')">COA</el-button>
            </div>
          </div>
          <g-l-a-summary
              type="opening-equity"
              ref="summary"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GLASummary from "../../../components/settings/settingsGlAccounts2/glaTabs/GLASummary";
export default {
  name: "OpeningBalanceEquity",
  components: {GLASummary},
  mounted() {
    this.$nextTick(() => {
      this.$refs.summary.loadList2()
    })
  },
  methods: {
    openJournals() {
      this.$router.push(
          `/journal-and-gl?companyId=${this.$route.query.companyId}&tab=sales`
      );
    },
    routerLink(page) {
      this.$router.push({
        name: page,
        query: { companyId: this.$route.query.companyId },
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    //display: flex;
    //justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      .settings-header {
        display: flex;
        justify-content: space-between;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
